// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SelectableProperties_product-props-container__DZS0b .SelectableProperties_title__0e\\+us {
  font-size: 20px;
  font-weight: bold;
}
.SelectableProperties_product-props-container__DZS0b .SelectableProperties_values-container__EMwZg {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 24px;
}`, "",{"version":3,"sources":["webpack://./src/views/ProductDetailView/SelectableProperties/SelectableProperties.module.scss","webpack://./src/styles/_typography.scss"],"names":[],"mappings":"AAGI;EACI,eAAA;EACA,iBCED;ADJP;AAII;EACI,aAAA;EACA,eAAA;EACA,cAAA;AAFR","sourcesContent":["@use \"styles/typography\";\n@use \"styles/colors\";\n.product-props-container {\n    .title {\n        font-size: typography.$header-s;\n        font-weight: typography.$bold;\n    }\n    .values-container {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 12px 24px;\n    }\n}","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"product-props-container": `SelectableProperties_product-props-container__DZS0b`,
	"title": `SelectableProperties_title__0e+us`,
	"values-container": `SelectableProperties_values-container__EMwZg`
};
export default ___CSS_LOADER_EXPORT___;
